import { CoreInterfaces, DTOs } from "src/core/Models";
import * as Constants from "./../../../core/Constants";
import { findQuestionInService } from "src/utils/shared";

export const ExtraServicesTaskProcessor: CoreInterfaces.ServiceTaskProcessor = (
  appState: CoreInterfaces.AppState,
  serviceDTO: DTOs.ServiceDTO
): void => {
  const q1101 = findQuestionInService(
    serviceDTO,
    Constants.ExtraServicesQuestions.Q1101
  );
  const q1102 = findQuestionInService(
    serviceDTO,
    Constants.ExtraServicesQuestions.Q1102
  );

  serviceDTO.data.tasks.forEach((taskDTO) => {
    if (taskDTO.data.code === Constants.ExtraServicesTasks.T1101) {
      taskDTO.state.isVisible = q1102.state.isShown;
      taskDTO.data.title = q1102.data.userValue as string;
    } else {
      taskDTO.state.isVisible =
        q1101.state.isShown && q1101.data.userValue === Constants.YesNo.Yes;
    }
  });
};
